class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super()

    this.listType = this.dataset.type
    this.products = this.getProducts()
  }

  async connectedCallback() {
    if(this.products.length === 0) {
      this.classList.add('hidden')
      return
    }
    const resourceLists = [...this.querySelectorAll('.resource-list')]
    const invalidPerList = await Promise.all(resourceLists.map((list, index) => this.renderProductCard(list, index)))
    const allInvalid = [...new Set(invalidPerList.flat())]
    if(allInvalid.length > 0) {
      const current = this.getProducts()
      const filtered = current.filter((handle) => !allInvalid.includes(handle))
      localStorage.setItem('viewedProducts', JSON.stringify(filtered))
    }
    const hasCards = this.querySelectorAll('[data-rv-slot]').length > 0
    if(this.getProducts().length === 0 || !hasCards) {
      this.classList.add('hidden')
    }
  }

  /**
   * @param {Element} resourceList
   * @param {number} order
   */
  async renderProductCard(resourceList, order) {
    let cardItems = [...resourceList.querySelectorAll('[data-rv-slot]')]
    let products = this.products
    if(cardItems.length < this.products.length) {
      products = this.products.slice(0, cardItems.length)
    }
    const invalidHandles = []
    const notFoundStatuses = [404, 410]
    await Promise.all(products.map(async (/** @type {string} */ productHandle, /** @type {number} */ index) => {
      const { data: productCardWrapper, status } = await this.fetchData(`/products/${productHandle}?sections=dynamic-product-card`)
      if (!productCardWrapper || !productCardWrapper['dynamic-product-card']) {
        if (status != null && notFoundStatuses.includes(status)) {
          invalidHandles.push(productHandle)
        }
        return
      }
      const productCardDiv = document.createElement('div')
      productCardDiv.innerHTML = productCardWrapper['dynamic-product-card']
      const productCardContent = productCardDiv.querySelector('#shopify-section-dynamic-product-card')
      if (!productCardContent) {
        if (status != null && notFoundStatuses.includes(status)) {
          invalidHandles.push(productHandle)
        }
        return
      }
      if(productCardContent.querySelector('[data-product-placeholder]')) {
        invalidHandles.push(productHandle)
        productCardDiv.remove()
        return
      }
      const productPriceBlock = productCardContent.querySelector('product-price')
      if(productPriceBlock) {
        productPriceBlock.classList.remove('paragraph')
        productPriceBlock.classList.add('h6')
      }
      if(cardItems[index]) {
        cardItems[index].innerHTML = productCardContent.innerHTML
      }
      productCardDiv.remove()
    }))

    cardItems.forEach((item) => {
      if(item.innerHTML.trim() === '') {
        if(order === 0 && this.listType === 'grid') {
          item.remove()
        } else {
          item.parentElement?.remove()
        }
      }
    })

    if(cardItems.length > products.length) {
      cardItems.forEach((item, index) => {
        if(index >= products.length) {
          if(order === 0) {
            if(this.listType === 'grid') {
              item.remove()
            } else {
              // @ts-ignore
              item.parentElement.remove()
            }
          } else {
            // @ts-ignore
            item.parentElement.remove()
          }
        }
      })
    }
    return invalidHandles
  }

  /**
   * @param {RequestInfo | URL} url
   * @returns {Promise<{ data: object | null, status?: number }>}
   */
  async fetchData(url) {
    try {
      const response = await fetch(url);
      const data = await response.json();
      if (!response.ok) {
        return { data: null, status: response.status };
      }
      return { data, status: response.status };
    } catch (error) {
      console.error('Fetch error:', error);
      return { data: null };
    }
  }

  getProducts() {
    return JSON.parse(localStorage.getItem('viewedProducts') || '[]');
  }
}
customElements.define('recently-viewed-products', RecentlyViewedProducts);
